import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { SunIcon, MoonIcon } from 'lucide-react';
const ThemeToggle: React.FC = () => {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <button onClick={toggleTheme} className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-40 bg-[#39FF14] rounded-full p-3 shadow-lg hover:scale-110 transition-transform duration-300" aria-label="Toggle theme" data-id="element-85">
      {theme === 'dark' ? <SunIcon className="w-5 h-5 text-black" data-id="element-86" /> : <MoonIcon className="w-5 h-5 text-black" data-id="element-87" />}
    </button>;
};
export default ThemeToggle;